import { z } from "zod";
const contactIdSchema = z.uuid().brand();
function asContactId(id) {
  return contactIdSchema.parse(id);
}
function mapContactDbToContact(contactDb, customFields) {
  return {
    id: contactDb.id,
    account_id: contactDb.account_id,
    email: contactDb.email,
    phone_number: contactDb.phone_number,
    ext_id: contactDb.ext_id,
    first_name: contactDb.first_name,
    last_name: contactDb.last_name,
    custom_fields: customFields,
    created_at: contactDb.created_at,
    updated_at: contactDb.updated_at
  };
}
function mapContactToBasicContact(contact) {
  return {
    first_name: contact.first_name,
    last_name: contact.last_name,
    email: contact.email,
    phone_number: contact.phone_number,
    ext_id: contact.ext_id
  };
}
function mapContactDbToIdentifiedBasicContact(contact) {
  return {
    id: contact.id,
    first_name: contact.first_name,
    last_name: contact.last_name,
    email: contact.email,
    phone_number: contact.phone_number,
    ext_id: contact.ext_id
  };
}
function toContactPublicApi(contactDb, customFields) {
  return {
    id: contactDb.id,
    account_id: contactDb.account_id,
    email: contactDb.email,
    phone_number: contactDb.phone_number,
    ext_id: contactDb.ext_id,
    first_name: contactDb.first_name,
    last_name: contactDb.last_name,
    custom_fields: customFields.map((customField) => ({
      key: customField.field_name,
      value: customField.data.value,
      type: customField.field_type,
      display_name: customField.display_name
    })),
    created_at: contactDb.created_at,
    updated_at: contactDb.updated_at
  };
}
export {
  asContactId,
  contactIdSchema,
  mapContactDbToContact,
  mapContactDbToIdentifiedBasicContact,
  mapContactToBasicContact,
  toContactPublicApi
};
//# sourceMappingURL=contact.js.map
